import React from 'react';
import { Heart, Users } from 'lucide-react';

const ConsultationsPage: React.FC = () => {
  return (
    <div className="consultations">
      <div className="consultations__container">
        {/* Header Section */}
        <div className="consultations__header">
          <h1 className="consultations__title">Health Professional</h1>
          <h2 className="consultations__subtitle">Book a consultation</h2>
          <p className="consultations__description">
            Ready to start your health and wellness journey?
          </p>
        </div>

        {/* Content Section */}
        <div className="consultations__content">
          {/* Health Professional Card */}
          <div className="consultations__card">
            <div className="consultations__card-header">
              <h3 className="consultations__card-title">Health Professional</h3>
              <div className="consultations__card-visual">
                <Heart size={24} />
              </div>
            </div>
            <p className="consultations__card-prompt">Book a consultation</p>
            <button
              className="consultations__booking-button"
              onClick={() => window.open('https://magiteque.life/contact-us/', '_blank')}
            >
              <span>Book Session</span>
              <span className="material-symbols-outlined consultations__arrow-icon">arrow_outward</span>
            </button>
          </div>

          {/* Join Consultant Group Card */}
          <div className="consultations__card">
            <div className="consultations__card-header">
              <h3 className="consultations__card-title">Consultant Group</h3>
              <div className="consultations__card-visual">
                <Users size={24} />
              </div>
            </div>
            <p className="consultations__card-prompt">Join a consultant group</p>
            <button
              className="consultations__booking-button"
              onClick={() => window.open('/panel/group-list', '_self')}
            >
              <span>Join Group</span>
              <span className="material-symbols-outlined consultations__arrow-icon">arrow_outward</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationsPage;



